import React, { Component } from 'react';
import ReactImageFallback from "react-image-fallback";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";
import AudioItem from "../includes/Slider/AudioItem";
import * as Utils from '../../lib/utils';
import {IMGIX_PATH, BUCKET_PATH} from "../../constants";
import {Button, Modal, ModalBody, ModalFooter} from "reactstrap";
import AuthService from "../../lib/AuthService";

class GraphicItem extends Component {

    constructor(props) {
        super(props);
         this.state = {
            visible: false,
            imageId: '',
            showModal : false,
            modalOptions : { showHeader : false, showFooter : false , title : '', id : "galleryModal", content: '' },
             selected_class : ' active',
             downLoad : true,
             showGalleryDelt: false,
             showConfirmDelete: false,
             asset_id:0

        };
        this.Auth = new AuthService();
        this.mToggle = this.mToggle.bind(this);
        this.initiateSlider = this.initiateSlider.bind(this);
        this.playAudio = this.playAudio.bind(this);
        this.closeAudio = this.closeAudio.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deltoggle = this.deltoggle.bind(this);
        this.deletecofrimtoggle = this.deletecofrimtoggle.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.confirmAssetDelete=this.confirmAssetDelete.bind(this);
    }

    mToggle() {
        this.setState({ showModal : true, modalOptions:{showModal: this.state.showModal} });
       // this.state.modalOptions.showModal = this.state.showModal;
    }

    initiateSlider(index) {

        var elems = document.querySelectorAll(".carousel-item");
        [].forEach.call(elems, function(el) {
            el.classList.remove("active");
        });

        //document.querySelectorAll('.carousel-item')[this.props.galIndex].classList.add('active');

        let data = {"index" :  this.props.galIndex};

        this.props.setItemId(data);
        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS') {
            let new_class = this.state.wrap_class+ ' '+ this.state.selected_class;
            this.setState({wrap_class : new_class});
        }
       /* else if(this.props.galleryInfo.gal_type === 'VIDEO') {

            //document.querySelectorAll('.video-react-video')[index].play();
        }*/
        this.props.showModal();

    }

    playAudio(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {console.log(i+"=============="+index);
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'glery-main sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    playVideo(index) {

        var element = document.getElementById("audio"+index);

        if( element.parentNode.classList.contains("player-static")) {

            var sounds = document.getElementsByTagName('audio');
            for(var i=0; i<sounds.length; i++){

                sounds[i].pause();

                if(i !== index) {
                    sounds[i].parentNode.classList.add("player-static");
                }
                else {
                    sounds[i].parentNode.classList.remove("player-static");
                }

            }

            this.setState({wrap_class : 'glery-main sl-item '});

            var audio = document.getElementById("audio"+index);
            audio.play();

        }

    }

    closeAudio(e,index) {

        e.preventDefault();
        e.stopPropagation();
        var sound = document.getElementById("audio"+index);
        sound.pause();
        sound.parentNode.classList.add("player-static");
    }

    componentDidMount() {
        this.setWrapperClass();
    }
    shouldComponentUpdate(nextProps, nextState){

        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
       if(this.props.detail.img_typ  !== prevProps.detail.img_typ ) {
           this.setWrapperClass();
        }
    }

    setWrapperClass() {
        let wrap_class = 'glery-main sl-item ';
        if(this.props.galleryInfo.gal_type === 'AUDIO' || this.props.galleryInfo.gal_type === 'VIDEO' || this.props.detail.img_typ === 'VDO' ||  this.props.detail.img_typ === 'AUDIO' ) {
            wrap_class += ' player-static';
            this.setState({play : false});
        }
        this.setState({wrap_class : wrap_class});
    }

    handleDownload(filename,name, fileId){
        Utils.forceDownload(this.props.pageSettingsData.config.BUCKET_PATH +'assets/slider/'+filename, filename);
        this.props.trackdownload({fileId : fileId});
    }
    handleDelete(filename,imgid, fileId){
        this.setState({
            showGalleryDelt: !this.state.showGalleryDelt,
            asset_id : imgid
        });
        let data = {"itemid" :  imgid};
        this.props.vignetsCount(data);
    }

    deltoggle() {
        this.setState({
            showGalleryDelt: !this.state.showGalleryDelt
        });
    }
    deletecofrimtoggle() {
        this.setState({
            showConfirmDelete: !this.state.showConfirmDelete,
            showGalleryDelt: false
        });
    }
    confirmDelete() {
        this.setState({
            showConfirmDelete: !this.state.showConfirmDelete
        });
        this.deltoggle();
    }
    confirmAssetDelete() {
        let data = {"itemid" :  this.state.asset_id, "module" :'Gallery',"action":'Delete',"relation_source":'Vignets', "updated_user" :this.Auth.getProfile().user_id};
        this.props.Gallerydelete(data);
        this.setState({
            showConfirmDelete: false,
            showGalleryDelt: false
        });
    }
    render() {
        console.log(this.props.galleryInfo.gal_type);
        console.log(this.props.source);
        console.log(this.state.asset_id);
        let item = this.props.detail;
        let itemIndex = this.props.galIndex;

        let imgpath = this.props.pageSettingsData.config.BUCKET_PATH +'assets/slider/'+ item.img_name;
        if(this.props.source === 'vignets') {
            imgpath = this.props.pageSettingsData.config.IMGIX_PATH+'assets/slider/'+item.img_name+'?q='+Math.random()+'&fit=crop&h=160&w=330&auto=enhance&dpr=3%203x';
        }

        let defImgSrc ='';

      //  let wrap_class = 'ind-galler-list ';

        if(this.props.galleryInfo.gal_type === 'MY_UPLOADS' && item.img_typ !== 'VDO') {
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'AUDIO' || this.props.detail.img_typ === 'AUDIO') {
            defImgSrc = require("../../assets/images/no-audio.jpg");
        }
        else if(this.props.galleryInfo.gal_type === 'VIDEO' || item.img_typ === 'VDO') {
            let img_name_arr = item.img_name.split('.');
            let img_name = '';
            if(img_name_arr.length > 0) {
                for(var i=0; i<img_name_arr.length-1; i++) {
                    img_name += img_name_arr[i];
                }
                img_name += '-1.jpg';
            }
            imgpath = this.props.pageSettingsData.config.BUCKET_PATH +'video_tn/'+ img_name;

            defImgSrc = require("../../assets/images/no-video.jpg");
        }
        else{
            defImgSrc = require("../../assets/images/no-gallery.jpg");
        }
        console.log(itemIndex);

        return (

            <div className={this.state.wrap_class} >
                <div className={this.props.galleryInfo.gal_type === 'AUDIO' || this.props.vgtyp === 'AUDIO' ? "gallery-thumb audio-position" : "gallery-thumb"}>
                    {(this.props.galleryInfo.gal_type === 'AUDIO' || this.props.vgtyp === 'AUDIO') &&
                    <button class="file-close" onClick={(e)=>this.closeAudio(e,itemIndex)}></button>
                    }

                    <div className="ind-tb glery-image" data-toggle="modal" data-target="#imagepreview" onClick={() => { (this.props.galleryInfo.gal_type === 'AUDIO' || this.props.vgtyp === 'AUDIO') ? this.playAudio(itemIndex): this.initiateSlider(itemIndex)  }} >
                        <ReactImageFallback
                            src={imgpath}
                            fallbackImage={defImgSrc}
                            initialImage={defImgSrc}
                            alt="cool image should be here"
                            className="my-image"  />
                    </div>
                    <div className={this.props.galleryInfo.viewMode === "grid"? "ind-tb glery-text audio-white " : "ind-tb glery-text"}>
                      <div className="gallery-info">
                        <p>{item.title}</p>
                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS'  && this.props.vgtyp !== 'VDO' &&
                        <div className="gallery-opt">
                            <nav onClick={(e) => this.handleDownload(this.props.detail.img_name,this.props.detail.title,this.props.detail.id)}  >
                            <button className={this.props.galleryInfo.viewMode === "grid" ? "add-image option-down ": "add-image"}></button>
                            </nav>
                            {this.props.source != 'vignets' &&
                            <nav className="header-option icon-lib delete-ico"
                                 onClick={(e) => this.handleDelete(this.props.detail.img_name, this.props.detail.img_id, this.props.detail.id)}/>
                            }
                        </div>
                        }
                        {this.state.downLoad && this.props.galleryInfo.gal_type === 'VIDEO' &&
                        <div className="gallery-opt">
                            <nav onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} >
                                <button className={this.props.galleryInfo.viewMode === "grid" ? "add-image option-down ": "add-image"}></button></nav>
                            {this.props.source != 'vignets' &&
                            <nav className="header-option icon-lib delete-ico"
                                 onClick={(e) => this.handleDelete(this.props.detail.img_name, this.props.detail.img_id, this.props.detail.id)}/>
                            }
                        </div>
                        }
                        {this.state.downLoad && this.props.vgtyp === 'VDO'&&
                        <div className="gallery-opt">
                        <nav onClick={(e) => this.handleDownload(this.props.detail.img_name,this.props.detail.title, this.props.detail.id)} >
                            <button className={this.props.galleryInfo.viewMode === "grid" ? "add-image option-down ": "add-image"}></button></nav>
                            {this.props.source != 'vignets' &&
                            <nav className="header-option icon-lib delete-ico"
                                 onClick={(e) => this.handleDelete(this.props.detail.img_name, this.props.detail.img_id, this.props.detail.id)}/>
                            }
                        </div>
                        }
                      </div>
                    </div>
                    {this.props.galleryInfo.viewMode === "list" &&
                        <div>
                        <div className="ind-tb gal-size">{parseFloat(item.img_size).toFixed(2)}MB</div>
                        <div className="ind-tb gal-user">{item.uploaded_by}</div>
                        <div className="ind-tb gal-date">{item.uploaded_on}</div>


                            {this.state.downLoad && this.props.galleryInfo.gal_type === 'MY_UPLOADS' && this.props.vgtyp !== 'VDO' && this.props.vgtyp !== 'AUDIO' &&
                            <div className="gallery-opt">
                            <nav onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} download>
                                <button className="add-image option-down" ></button>
                            </nav>
                                {this.props.source != 'vignets' &&
                                <nav className="header-option icon-lib delete-ico"
                                     onClick={(e) => this.handleDelete(this.props.galleryData.galleryItems[itemIndex].img_name, this.props.galleryData.galleryItems[itemIndex].img_id, this.props.galleryData.galleryItems[itemIndex].id)}/>
                                }
                            </div>
                            }
                            {this.state.downLoad && (this.props.galleryInfo.gal_type === 'AUDIO' || this.props.vgtyp === 'AUDIO' )&&
                            <div className="gallery-opt">
                            <nav onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)} download> <button className="add-image option-down" ></button></nav>
                                {this.props.source != 'vignets' &&
                                <nav className="header-option icon-lib delete-ico"
                                     onClick={(e) => this.handleDelete(this.props.detail.img_name, this.props.galleryData.galleryItems[itemIndex].img_id, this.props.galleryData.galleryItems[itemIndex].id)}/>
                                }
                            </div>
                            }
                            {this.state.downLoad && (this.props.galleryInfo.gal_type === 'VIDEO' || this.props.vgtyp === 'VDO') &&
                            <div className="gallery-opt">
                            <nav onClick={(e) => this.handleDownload(this.props.galleryData.galleryItems[itemIndex].img_name,this.props.galleryData.galleryItems[itemIndex].title, this.props.galleryData.galleryItems[itemIndex].id)}  download> <button className="add-image option-down" ></button></nav>
                                {this.props.source != 'vignets' &&
                                <nav className="header-option icon-lib delete-ico"
                                     onClick={(e) => this.handleDelete(this.props.detail.img_name, this.props.galleryData.galleryItems[itemIndex].img_id, this.props.galleryData.galleryItems[itemIndex].id)}/>
                                }
                            </div>
                            }
                    </div>
                    }
                </div>

                { (this.props.galleryInfo.gal_type === 'AUDIO' || this.props.vgtyp === 'AUDIO' ) && <AudioItem item = {item} id={itemIndex}  /> }
                {this.state.showGalleryDelt &&

                <Modal isOpen={this.state.showGalleryDelt} id="delete-vignets">
                    <ModalBody>
                        {this.props.galleryInfo.vignetsCount ?
                            <div className="alert alert-default text-center" role="alert">
                                This File is using for <label>{this.props.galleryInfo.vignetsCount}</label> vignets.
                            </div> :
                            <div className="alert alert-default text-center" role="alert">
                                Are you sure to delete this file ?
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.deltoggle}>Cancel</Button>
                        <Button color="primary" onClick={this.confirmDelete}>Confirm</Button>
                    </ModalFooter>
                </Modal>
                }
                {this.state.showConfirmDelete &&

                <Modal isOpen={this.state.showConfirmDelete} id="delete-vignets">
                    <ModalBody>
                           <div className="alert alert-default text-center" role="alert">
                                 The file will be deleted permanently ?
                            </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.deletecofrimtoggle}>No</Button>
                        <Button color="primary" onClick={this.confirmAssetDelete}>Yes</Button>
                    </ModalFooter>
                </Modal>
                }
            </div>

        );
    }


}

function mapStateToProps(state) {
    return {
        galleryInfo  :state.gallery.galleryUpdate,
        galleryData  :state.gallery.galleryData,
        galleryUpdate  :state.gallery.galleryUpdate,
        pageSettingsData : state.pages.pageSettings
    };

}

export default  withRouter(connect(mapStateToProps, {
    setItemId : galleryActions.setItemId,
    vignetsCount : galleryActions.vignetscount,
    download : galleryActions.downloadFile,
    Gallerydelete : galleryActions.deleteFile,
    trackdownload : galleryActions.trackDownload,
})(GraphicItem));




// WEBPACK FOOTER //
// ./src/components/gallery/GraphicItem.js